import $ from "jquery";
import VueTheMask from "vue-the-mask";
import Vue from "vue";
import VueRouter from "vue-router";
import "whatwg-fetch"; // Nécessaire pour faire marcher le 'fetch' sur IE 11
import { routes } from "./router/routes";
import VueMoment from "vue-moment";
import "moment/locale/fr.js";
import { EventBus } from "./components/Controls/EventBus";
import "bootstrap";
import "bootstrap-notify";
import { ServicesFactoryInstance } from "./components/Controls/ServicesFactory";
import EventConstants from "./components/Controls/EventConstants";
import "@/globalComponents";
import globalDirectives from "./shared/directives/";
import { store } from "./store/store";
import ElementUI from "element-ui";
import "@/assets/element-ui-no-icons.css";
import locale from "element-ui/lib/locale/lang/fr";

Vue.use(ElementUI, { locale });

Vue.use(VueMoment);
Vue.use(VueRouter);
Vue.use(VueTheMask);
Vue.use(globalDirectives);

const window: any = document.defaultView;
window.$ = require("jquery")(window);
window.jQuery = $;

// Cette ligne permet à l'extension VueDevTools d'accéder à la configuration de l'application
if (process.env.NODE_ENV === "development") {
	Vue.config.devtools = true;
} else {
	Vue.config.devtools = false;
}

// -----------------------------------------------

let base = "/" + window.location.pathname.split("/")[1];
if (routes.filter(r => r.path.indexOf(base) == 0).length > 0) {
	base = "";
}

ServicesFactoryInstance.urlBase = base;

const router = new VueRouter({
	mode: "hash",
	routes: routes,
	base: base
});

new Vue({
	el: "#appTemplate",
	store,
	router: router,
	render: h => h(require("./app.vue.html")),
	mounted: () => {
		if (window.jimo != null) {
			return;
		}
        window.jimo = [];

        const s = document.createElement("script");

        s.type = "text/javascript";
        s.async = true;
        s.src = "https://undercity.usejimo.com/jimo-invader.js";
        window.JIMO_PROJECT_ID = "5d17dc49-770e-4320-8e33-c3f18ec49227";
        window.JIMO_MANUAL_INIT = true;
        document.getElementsByTagName("head")[0].appendChild(s);
    }
});

// Gestion de l'affichage des onglets lors de la navigation d'URL
router.afterEach((to, from) => {
	let titre = to.name;
	if (to.query != undefined && to.query.titre != undefined) {
		if (to.query.titre as string == undefined) {
			titre = to.query.titre[0] as string;
		} else {
			titre = to.query.titre as string;
		}
	}

	if (to.matched[0] != undefined) {
		EventBus.$emit(EventConstants.MANAGE_TAB_FROM_ROUTE, {
			path: {
				path: to.path,
				name: to.name,
				hash: to.hash,
				query: to.query,
				params: to.params
			},
			name: titre,
			vue: to.matched[0].instances
		});
	} else {
		EventBus.$emit(EventConstants.MANAGE_TAB_FROM_ROUTE, {
			path: {
				path: to.path,
				name: to.name,
				hash: to.hash,
				query: to.query,
				params: to.params
			},
			name: titre
		});
	}
});

Vue.filter("formatMontant", (value) => {
	if (value == 0 || value == null) {
		return "0,00";
	}

	const val = (value / 1).toFixed(2);
	const parts = val.toString().split(".");

	parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");

	return parts.join(",");
});

Vue.filter("formatMontantPrecision", function(value, parameter) {
	if (parameter == undefined) {
		var val = (value / 1).toPrecision().replace(".", ",");
		var parts = val.toString().split(",");
		parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");

		return parts.join(",");
	} else {
		var val = (value / 1).toPrecision(parameter).replace(".", ",");
		var parts = val.toString().split(",");
		parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");

		return parts.join(",");
	}
});

Vue.filter("capitalize", function(value) {
	if (!value) return "";
	
	// Convertit en minuscules puis met en majuscule la première lettre
	return value.toLowerCase().charAt(0).toUpperCase() + value.toLowerCase().slice(1);
});



// WEBPACK FOOTER //
// ./src/boot.ts